module.exports = __webpack_public_path__ + "img/guide28800.c1363266.png";